import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getMyWalletBalanceAction,
  getPackagesAction,
  saveStepData,
} from "../../../Redux/AddOrEditPartner/AddOrEditPartnerActions";
import {
  clearStep4ValidationError,
  clearStepErrors,
  setStep4selectedPackage,
  setStep4selectedPackageFullObject,
  setStepErrors,
  setStepsFormLoading,
  turnOnStep4isSubmittedFlag,
} from "../../../Redux/AddOrEditPartner/AddOrEditPartnerSlice";
import Swal from "sweetalert2";
import RowLoader from "../../../Components/UI/RowLoader";
import HeaderStep from "./HeaderStep";
import ListPackagesStepFour from "../../../Components/ListPackagesStepFour/ListPackagesStepFour";
import { PAYMENT_CHANNELSS } from "../../../constants/globals";
import { purchasePackageStep4 } from "../../../apis";
import { useLocation } from "react-router-dom";

const PartnerStepFour = () => {
  const location = useLocation();
  const [currentTab, setCurrentTab] = useState(1);
  const [voucherTab, setVoucherTab] = useState("noVoucher"); // "haveVoucher" | "noVoucher"
  const [voucherCode, setVoucherCode] = useState("");
  const [submitCode, setSubmitCode] = useState(false);
  const { step1, step4, isLoading } = useSelector(
    (state) => state?.AddOrEditPartner
  );
  const { stepInfo: Step1Info } = step1;

  const {
    validationObject,
    AllPackages,
    myWalletBalance,
    selectedPackage,
    selectedPackageFullObject,
    isSubmittedFlag,
    getPackagesLoading,
  } = step4;

  const isOnlinePayment =
    Step1Info?.client?.payment_channel_id === PAYMENT_CHANNELSS.OnlinePayment;

  const dispatch = useDispatch();
  const [isConfirmed, setIsConfirmed] = useState(false);

  useEffect(() => {
    dispatch(setStep4selectedPackage(""));
    dispatch(setStep4selectedPackageFullObject({}));
    dispatch(getMyWalletBalanceAction());
  }, []);

  useEffect(() => {
    dispatch(getPackagesAction(Step1Info?.id, voucherCode));

    return () => {
      dispatch(clearStep4ValidationError());
    };
  }, [submitCode]);

  const validateRequiredInput = () => {
    if (!selectedPackage) {
      dispatch(
        setStepErrors({
          errorsList: { package_validation: ["This field is required"] },
          stepNumber: 4,
        })
      );
    } else {
      dispatch(clearStepErrors(4));
    }
  };

  useEffect(() => {
    validateRequiredInput();
  }, [selectedPackage]);

  const handleSubmit = () => {
    if (!selectedPackage) {
      dispatch(turnOnStep4isSubmittedFlag());
      return;
    }

    if (!isConfirmed) {
      Swal.fire({
        text: "You must confirm your selection",
        icon: "error",
      });
      return;
    }

    const payload = {
      client_id: Step1Info?.id,
      package_id: selectedPackage,
    };
    if (voucherTab === "haveVoucher" && voucherCode) {
      payload.haveVoucher = voucherCode;
    }
    if (isOnlinePayment) {
      dispatch(setStepsFormLoading(true));
      purchasePackageStep4(
        payload.client_id,
        payload.package_id,
        payload?.haveVoucher
      )
        .then((response) => {
          window.open(response.data.data.redirectUrl, "_blank");
        })
        .catch((error) => {
          console.error(error);

          Swal.fire({
            title: "Payment Error",
            text:
              error.response?.data?.message ||
              "Something went wrong. Please try again.",
            icon: "error",
            confirmButtonText: "OK",
          });
        })
        .finally(() => {
          dispatch(setStepsFormLoading(false));
        });
    } else {
      dispatch(
        saveStepData(payload, 4, false, () => {
          Swal.fire({
            title: "Good!",
            text: "Package selected successfully",
            icon: "success",
            allowOutsideClick: false,
          });
        })
      );
    }
  };

  const packageCategories = Object.values(AllPackages?.packageCategories || {});
  const packages = AllPackages?.packageCategoriesData?.[currentTab];

  const filterTabsArray = packageCategories.filter((t) => {
    return AllPackages?.packageCategoriesData?.[t.id];
  });

  const currentTabIcon = filterTabsArray.find(
    (tab) => tab.id == currentTab
  )?.icon;

  const handleSelectTab = (voucherStatus) => {
    setVoucherTab(voucherStatus);
    dispatch(setStep4selectedPackage(""));
    dispatch(setStep4selectedPackageFullObject({}));
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const errorMsg = params.get("errorMsg");
    const errorCode = params.get("errorCode");

    if (errorMsg && errorCode) {
      Swal.fire({
        icon: "error",
        title: "An Error Occurred",
        text: `${errorMsg} (Error Code: ${errorCode})`,
        confirmButtonText: "OK",
      });
    }
  }, [location.search]);

  if (getPackagesLoading)
    return (
      <div className="tw-flex tw-justify-center">
        <RowLoader />
      </div>
    );

  return (
    <>
      <HeaderStep
        first_name={Step1Info?.first_name}
        second_name={Step1Info?.second_name}
        last_name={Step1Info?.last_name}
        stepName={"Package Data"}
        stepNumber={"4"}
      />

      <div className="card-body">
        {/* Wallet info */}
        {!isOnlinePayment && (
          <>
            <div className="d-flex flex-column text-right">
              <div className="media-right text-right d-flex align-items-center justify-content-end">
                <p className="tw-border-2 tw-rounded-lg tw-p-1 tw-px-2 tw-border-primary/50 tw-min-w-fit tw-text-center max-md:tw-text-[12px]">
                  <span className="tw-text-primary mr-1">Current Wallet:</span>
                  <span>{myWalletBalance?.balance ?? 0} E.M</span>
                </p>
              </div>
            </div>

            {selectedPackage && (
              <div className="media-right text-right d-flex align-items-center justify-content-end tw-mt-1">
                <p className="tw-border-2 tw-p-1 tw-border-red-600/50 tw-min-w-[200px] tw-rounded-lg tw-text-center">
                  <span className="tw-text-primary mr-1">Updated Wallet:</span>
                  <span>
                    {selectedPackageFullObject.price_after_voucher !== 0 &&
                    selectedPackageFullObject.price_after_voucher
                      ? myWalletBalance?.balance -
                        (selectedPackageFullObject?.price_after_voucher || 0)
                      : myWalletBalance?.balance -
                        (selectedPackageFullObject?.total_price || 0)}{" "}
                    E.M
                  </span>
                </p>
              </div>
            )}
          </>
        )}

        {/* Voucher / No Voucher Tabs */}
        <div className="tw-flex tw-justify-center tw-gap-4 tw-mt-4">
          <button
            onClick={() => handleSelectTab("haveVoucher")}
            className={`tw-py-2 tw-px-4 !tw-rounded-lg ${
              voucherTab === "haveVoucher"
                ? "tw-bg-primary tw-text-white"
                : "tw-bg-gray-200"
            }`}
          >
            Have a Voucher
          </button>
          <button
            onClick={() => {
              handleSelectTab("noVoucher");
              setSubmitCode(false);
              setVoucherCode("");
            }}
            className={`tw-py-2 tw-px-4 !tw-rounded-lg ${
              voucherTab === "noVoucher"
                ? "tw-bg-primary tw-text-white"
                : "tw-bg-gray-200"
            }`}
          >
            No Voucher
          </button>
        </div>

        {/* Voucher Code Input */}
        {voucherTab === "haveVoucher" && (
          <div className="tw-my-3 tw-flex tw-gap-2 tw-w-1/2 tw-min-w-[300px] tw-mx-auto">
            <input
              type="text"
              value={voucherCode}
              onChange={(e) => setVoucherCode(e.target.value)}
              placeholder="Enter voucher code"
              className="tw-border tw-rounded-lg tw-px-3 tw-py-2"
            />
            <button
              type="button"
              onClick={() => {
                if (!voucherCode.trim()) {
                  Swal.fire({
                    icon: "warning",
                    title: "Please enter a voucher code first",
                  });
                  return;
                }
                setVoucherCode(voucherCode.trim());
                setSubmitCode(true);
              }}
              className="tw-bg-gray-200 !tw-rounded-lg tw-text-sm hover:tw-bg-gray-300 tw-px-4 tw-py-2"
            >
              Check
            </button>
          </div>
        )}
        {!(validationObject?.length > 0) &&
          !(voucherTab === "haveVoucher" && !submitCode) && (
            <ListPackagesStepFour
              Step1Info={Step1Info}
              currentTab={currentTab}
              currentTabIcon={currentTabIcon}
              filterTabsArray={filterTabsArray}
              isConfirmed={isConfirmed}
              isSubmittedFlag={isSubmittedFlag}
              packages={packages}
              selectedPackage={selectedPackage}
              setCurrentTab={setCurrentTab}
              setIsConfirmed={setIsConfirmed}
              validationObject={validationObject}
            />
          )}

        {validationObject?.length > 0 && (
          <p className="tw-text-red-500 tw-text-center !tw-mt-2">
            {validationObject?.[0]}
          </p>
        )}

        {/* Submit Button */}
        <div className="d-flex w-100">
          <button
            disabled={!packages?.length > 0}
            type="button"
            onClick={handleSubmit}
            className="btn btn-primary ml-auto mt-5 !tw-w-[100px]"
          >
            {isLoading ? <RowLoader paddingStyle="tw-py-0" /> : "Submit"}
          </button>
        </div>
      </div>
    </>
  );
};

export default PartnerStepFour;
